import { render } from "./PartyCom.vue?vue&type=template&id=318629c6&scoped=true"
import script from "./PartyCom.vue?vue&type=script&lang=js"
export * from "./PartyCom.vue?vue&type=script&lang=js"

import "./PartyCom.vue?vue&type=style&index=0&id=318629c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318629c6"]])

export default __exports__